import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { of } from "rxjs";
import {
  catchError,
  concatMap,
  filter,
  map,
  withLatestFrom,
} from "rxjs/operators";
import { EaredDoveService } from "../../eared-dove/eared-dove.service";
import { selectActiveWorkspace } from "../../workspace/state/workspaces.selectors";

import * as PersistentNotificationActions from "./persistent-notification.actions";
import { VIEWED_PERSISTENT_NOTIFICATION_STORAGE_KEY } from "./persistent-notification.model";
import { selectPersistentNotificationState } from "./persistent-notification.selectors";

@Injectable()
export class PersistentNotificationEffects {
  setActiveWorkspace$ = createEffect(() => {
    return this.store
      .select(selectActiveWorkspace)
      .pipe(filter((w) => !!w))
      .pipe(
        concatMap(() => [
          PersistentNotificationActions.loadPersistentNotifications(),
        ]),
      );
  });

  loadPersistentNotifications$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PersistentNotificationActions.loadPersistentNotifications),
      concatMap(() =>
        this.earedDove.getPersistentNotifications().pipe(
          map((notifications) =>
            PersistentNotificationActions.loadPersistentNotificationsSuccess({
              notifications,
            }),
          ),
          catchError((error) =>
            of(
              PersistentNotificationActions.loadPersistentNotificationsFailure({
                error,
              }),
            ),
          ),
        ),
      ),
    );
  });

  markAllPersistentNotificationsViewed$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PersistentNotificationActions.markAllPersistentNotificationViewed),
      withLatestFrom(this.store.select(selectPersistentNotificationState)),
      concatMap(([, notifications]) => {
        localStorage.setItem(
          VIEWED_PERSISTENT_NOTIFICATION_STORAGE_KEY,
          JSON.stringify(notifications.map((n) => n.uuid)),
        );
        return [
          PersistentNotificationActions.markAllPersistentNotificationViewedSuccess(),
        ];
      }),
    );
  });

  constructor(
    private actions$: Actions,
    private earedDove: EaredDoveService,
    private store: Store,
  ) {}
}
